module.exports = __webpack_public_path__ + "img/header-memoireRingsGold@2x.c5c425a.webp";